<template>
    <div class="wrapper-content">
        <section class="banner">
            <div class="banner__figure">
                <div class="container">
                    <div class="banner__body">
                        <div class="banner__subtitle d-title">
                            <p class="md">Ваш никах<br />пройдет на высоте</p>
                            <p class="mm">Ваш<br />никах пройдет<br />на высоте</p>
                        </div>
                        <h1 class="banner__title">
                            <span class="md">Zaman - первый сертифицированный<br />халяль ресторан в Уфе</span>
                            <span class="mm">
                                Zaman - первый<br />
                                в Уфе сертифицированный<br />
                                халяль ресторан
                            </span>
                        </h1>
                        <div class="banner__buttons md">
                            <a href="#booking"
                                ><button class="banner__btn btn-nikah btn-white">
                                    <span>Забронировать</span>
                                </button></a
                            >
                            <a href="#menu"
                                ><button class="banner__btn btn-nikah btn-white">
                                    <span>Смотреть меню</span>
                                </button></a
                            >
                        </div>
                    </div>
                </div>
                <div class="banner__buttons mm">
                    <a href="#booking"
                        ><button class="banner__btn btn-nikah btn-white">
                            <span>Забронировать</span>
                        </button></a
                    >
                    <a href="#menu"
                        ><button class="banner__btn btn-nikah btn-white">
                            <span>Смотреть меню</span>
                        </button></a
                    >
                </div>
            </div>
        </section>
    </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.banner {
    background-image: url("@/assets/images/nikahi/banner/banner.webp");
    background-repeat: no-repeat;
    background-size: 77vw;
    background-position-x: right;
}
@media (max-width: 1200px) {
    .banner {
        background-size: cover;
        background-position-x: left;
    }
}
@media (max-width: 992px) {
    .banner {
        background-position-x: center;
    }
}
@media (max-width: 768px) {
    .banner {
        background-image: url("@/assets/images/nikahi/mobile/banner.png");
        background-position-x: center;
        background-position-y: 2rem;
        min-height: 750px;
    }
    .banner__btn {
        min-width: 248px;
    }
}
.banner__figure {
    background-image: url("@/assets/images/nikahi/banner/figure.webp");
    background-repeat: no-repeat;
    background-size: 65% 100%;
    height: 784px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    position: relative;
    overflow: hidden;
}
.banner__figure::before {
    content: "";
    position: absolute;
    background-image: url("@/assets/images/nikahi/banner/union.webp");
    background-repeat: no-repeat;
    background-size: contain;
    width: 100%;
    height: 100%;
    z-index: 0;
}
@media (max-width: 768px) {
    .banner__figure::before {
        background-image: url("@/assets/images/nikahi/mobile/union.webp");
    }
}
@media (max-width: 768px) {
    .banner__figure {
        background-image: url("@/assets/images/nikahi/mobile/figure.webp");
        background-size: 100% 50%;
        height: 750px;
        padding-top: 80px;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        -ms-flex-direction: column;
        flex-direction: column;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -webkit-box-pack: justify;
        -ms-flex-pack: justify;
        justify-content: space-between;
    }
}
.banner__body {
    position: relative;
    z-index: 1;
}
@media (max-width: 768px) {
    .banner__body {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        -ms-flex-direction: column;
        flex-direction: column;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        text-align: center;
    }
}
.banner__title {
    font-weight: 400;
    font-size: 24px;
    line-height: 32.4px;
    color: var(--black);
    margin-top: 20px;
}
@media (max-width: 768px) {
    .banner__title {
        font-size: 18px;
        line-height: 24.3px;
    }
}
.banner__buttons {
    display: flex;
}
.banner__buttons a {
    color: inherit;
}
.banner__buttons a:last-child {
    margin-left: 20px;
}
.banner__btn {
    min-width: 296px;
    margin-top: 35px;
}
.banner__btn:hover,
.banner__btn:focus {
    opacity: 0.5;
    transition: 0.2s ease 0.2s;
}
@media (max-width: 768px) {
    .banner__buttons {
        flex-direction: column;
        margin-bottom: 70px;
    }
    .banner__buttons a:last-child {
        margin-left: 0;
    }
    .banner__btn {
        margin-top: 10px;
        -webkit-backdrop-filter: blur(5px);
        backdrop-filter: blur(5px);
    }
}
.banner__img {
    position: absolute;
    top: 0;
    left: 0;
}
.banner__img img {
    width: 100%;
    height: 100%;
    -o-object-fit: cover;
    object-fit: cover;
}
</style>
